<template>
<div v-if="stockInfo" class="tab-wrapper">
  <h3 class="mb16">房间明细</h3>
  <div class="content">
    <div class="item pt16 pb16">
      <h4 class="mb8">房间数</h4>
      <table-list :showPage ="false" :columns="roomColumns" :data="stockInfo.rooms" :loading="roomLoading"></table-list>
    </div>
    <div class="item pt16 pb16">
      <h4 class="mb8">床位数</h4>
      <table-list :showPage ="false" :columns="bedColumns" :data="stockInfo.beds" :loading="bedLoading"></table-list>
    </div>
  </div>
</div>
 
</template>
 
<script type="text/ecmascript-6">
import defaultImg from '@/assets/filedefault.jpg'
 import TableList from "components/TableList/index";

export default {
  props:{
    stockInfo:{
      type:Object,
      default:null
    }
  },
components:{
  TableList
},
 data () {
  return {
    defaultImg:defaultImg,
    roomLoading:false,
    bedLoading:false,
    roomColumns:[
     {
        title: "房间号",
        key: "stockNumber",
        align: "center"
      
      },
      {
        title: "标准租金",
        key: "housePrice",
        align: "center"
      },
      {
        title: "实际租期",
        key: "actualHousePrice",
        align: "center"
      },
      {
        title: "标准服务费",
        key: "servicePrice",
        align: "center"
      },
      {
        title: "实际服务费",
        key: "actualServicePrice",
        align: "center"
      },
      {
        title: "标准押金",
        key: "depositPrice",
        align: "center"
      },
      {
        title: "实际押金",
        key: "actualDepositPrice",
        align: "center"
      }
    ],
    roomList:[],
    bedColumns:[
       {
        title: "床位号",
        key: "stockNumber",
        align: "center"
      
      },
      {
        title: "标准租金",
        key: "housePrice",
        align: "center"
      },
      {
        title: "实际租期",
        key: "actualHousePrice",
        align: "center"
      },
      {
        title: "标准服务费",
        key: "servicePrice",
        align: "center"
      },
      {
        title: "实际服务费",
        key: "actualServicePrice",
        align: "center"
      },
      {
        title: "标准押金",
        key: "depositPrice",
        align: "center"
      },
      {
        title: "实际押金",
        key: "actualDepositPrice",
        align: "center"
      }
    ],
    bedList :[]

  };
 },
 methods:{

 }
}
</script>




